document.addEventListener("scroll", (e) => {
    updateMenu();
});

window.addEventListener('DOMContentLoaded', (e) => {
    updateMenu();
});

function updateMenu() {
    var scrollDistance = document.documentElement.scrollTop;
    var windowHeight = window.innerHeight;
    var header = document.querySelector('header.wp-block-template-part');
    var headerHeight = header.clientHeight;

    header.style.setProperty('--header-height', headerHeight + 'px');

    if ( scrollDistance > (2 * headerHeight) ) {
        header.classList.add('prepare-fixed');

    } else {
        header.classList.remove('prepare-fixed');
    }

    if ( scrollDistance > windowHeight ) {
        header.classList.add('fixed');
    } else {
        header.classList.remove('fixed');
    }
}